<template>
  <div>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">
            {{ this.parentObject.pageTitle
            }}<span class="page_title_value">{{
              this.parentObject.pageTitleValue
            }}</span>
          </h2>
        </v-row>

        <v-col class="mt-n4 mb-2">
          <v-row>
            <v-btn
              v-model="goBtn"
              @click="backButton()"
              color="orange"
              class="white--text"
              >{{$t('button.back')}}</v-btn
            >
          </v-row>
        </v-col>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-row>
            <v-toolbar flat>
              <v-toolbar-title
                >{{$t('miscpayrolllsitreport.miscpayrolllistingforpayoutyear')}}
                <span v-if="dataItems[0]" class="blue--text">
                    {{ this.dataItems[0].payitemdesc }}</span
                  >
                <div v-if="this.showDate" class="title-1">  
                 {{$t('statutoryexportcommonused.payoutyear')}}
                  <span class="blue--text">
                    {{ this.data.formData.poyr }}</span
                  >, {{$t('statutoryexportcommonused.payoutmonth')}}
                  <span class="blue--text">
                    {{ this.data.formData.pomth }}</span
                  >, {{$t('columns.company')}}
                  <span v-if="dataItems[0]" class="blue--text">
                    {{ this.dataItems[0].compnydesc }}</span
                  >               
                </div>
                <div v-if="this.showID" class="title-1">
                  {{$t('claimrecordlisting.payoutcode')}}
                  <span class="blue--text">
                    {{ this.dataItems[0].payoutcode }}</span
                  >, 
                  
                  {{$t('columns.company')}}
                  <span v-if="dataItems[0]" class="blue--text">
                    {{ this.dataItems[0].compnydesc }}</span
                  >
                </div>

              </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-avatar class="profile mr-5" size="40" tile>
                <img
                  :src="`${publicPath}images/export_pdf.png`"
                  @click="printPDF"
                />
              </v-avatar>

              <v-avatar class="profile" size="40" tile>
                <img
                  :src="`${publicPath}images/export_csv.png`"
                  @click="getCSV"
                />
              </v-avatar>
            </v-toolbar>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                hide-default-footer
                :headers="dataHeader"
                :items="dataItems"
                :items-per-page="1000"
                multi-sort
                :no-data-text="this.$t('vdatatable.norecordsfound')"
              >
              </v-data-table>

              <v-toolbar flat color="#faead8" dense>
                <v-col cols="9" sm="9" class="mr-9"></v-col>
                <v-col cols="2" sm="2" class="total">{{this.$t('bankpaymentlistingreport.total')}}</v-col>
                <v-col cols="2" sm="2" class="ml-n6">
                  <span class="black--text total"> {{ this.total }} </span>
                </v-col>
              </v-toolbar>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  props: {
    parentObject: Object,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },

      data: {
        formData: {
          poyr: this.$route.params.formData.poyr,
          pomth: this.$route.params.formData.pomth,
          poid: this.$route.params.formData.poid,
          compnyid: this.$route.params.formData.compnyid,
          compnycode: this.$route.params.formData.compnycode,
          payitemid: this.$route.params.formData.payitemid,
          id: this.$route.params.formData.id,
          payitemcode: this.$route.params.formData.payitemcode,
          payoutcode: this.$route.params.formData.payoutcode
        },

      },

      dataHeader: [
        { text: this.$t('columns.no'), width: "7%", value: "id" },
        { text: this.$t('columns.name'), width: "10%", value: "psnname" },
        { text: this.$t('columns.staffid'), width: "8%", value: "staffcode" },
        { text: this.$t('columns.branch'), width: "7%", value: "brchcode" },
        { text: this.$t('columns.department'), width: "7%", value: "deptcode" },
        { text: this.$t('recfamdetails.icno'), width: "10%", value: "idno" },               
        { text: this.$t('miscpayrolllsitreport.oldicno'), width: "10%", value: "oldidno" },
        { text: this.$t('trainingrecord.amount'), width: "15%", value: "amount", align: "right" },
      ],

      tableOpt: {
        itemsPerPage: -1,
      },

      showID: false,
      showDate: false,
      showTotal: false,
      total: null,
      amount: null,

      dataItems: [],

      yearList: [],
      monthList: [],
      payoutcodeList: [],
      compnycodeList: [],
      payitemcodeList: [],

      goBtn: false,
    };
  },

  methods: {
    backButton() {
      this.$router.push({ name: "parameterMisc" });
    },

    loadStaffMisc() {
      this.goBtn = true;

      const vm = this;
      this.$store.dispatch('post', {
        url: `/miscpayroll/${this.$store.getters.userId}`,
        payload: this.data
        })
        .then(function (res) {
          
          vm.dataItems = res.data.rec;
          console.log('dataItems', vm.dataItems)
          
          let getamount = [];

          for (let i = 0; i < vm.dataItems.length; i++) {
            vm.dataItems[i].id = i + 1;
            getamount.push(
              parseFloat(vm.dataItems[i].amount.replace(/,/g, ""))
            );
          }
          let gettotal = getamount.reduce(function (a, b) {
            return a + b;
          }, 0);

          gettotal = gettotal.toFixed(2);

          vm.total = gettotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          vm.showTotal = true;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    printPDF() {
      const doc = new jsPDF({
        orientation: "landscape",
      });

      var head = [
        { title: this.$t('columns.no'), dataKey: "id" },
        { title: this.$t('columns.name'), dataKey: "psnname" },
        { title: this.$t('columns.staffid'), dataKey: "staffcode" },
        { title: this.$t('columns.branch'), dataKey: "brchcode" },
        { title: this.$t('columns.department'), dataKey: "deptcode" },
        { title: this.$t('recfamdetails.icno'), dataKey: "idno" },       
        { title: this.$t('miscpayrolllsitreport.oldicno'), dataKey: "oldidno" },       
        { title: this.$t('trainingrecord.amount'), dataKey: "aprvamt", align: "right" },
        { title: this.$t('bankpaymentlistingreport.total'), dataKey: "total" },
      ];

      let body = [];

      for (var i = 0; i < this.dataItems.length; i++) {
        body.push({
          id: this.dataItems[i].id,
          psnname: this.dataItems[i].psnname,
          staffcode: this.dataItems[i].staffcode,
          brchcode: this.dataItems[i].brchcode,
          deptcode: this.dataItems[i].deptcode,
          idno: this.dataItems[i].idno,         
          oldidno: this.dataItems[i].oldidno,
          aprvamt: this.dataItems[i].amount,
        });
      }
      body.push({
        total: this.total,
      });
      
      doc.text(this.$t('miscpayrolllsitreport.miscpayrolllistingforpayoutyear'), 10, 10);
      doc.text(this.dataItems[0].payitemdesc.toString(), 71, 10);

      if (this.formData.poid) {
        doc.text(this.$t('claimrecordlisting.payoutcode'), 150, 10);
        doc.text(this.dataItems[0].payoutcode.toString(), 185, 10);
        doc.text(this.$t('columns.company'), 230, 10);
        doc.text(this.formData.compnycode, 260, 10);
      } 
      else {
        doc.text(this.$t('statutoryexportcommonused.payoutyear'), 150, 10);
        doc.text(this.formData.poyr.toString(), 182, 10);
        doc.text(this.$t('statutoryexportcommonused.payoutmonth'), 198, 10);
        doc.text(this.formData.pomth.toString(), 235, 10);
        doc.text(this.$t('columns.company'), 240, 10);
        doc.text(this.formData.compnycode, 265, 10);
      }
      
      doc.autoTable(head, body);
      doc.save(this.$t('miscpayrolllsitreport.miscpaytolllisting') + "-" + this.dataItems[0].payoutcode.toString() + ".pdf");
    },

    objectToCSV(data) {
      const csvRows = [];

      // get header
      const headers = Object.keys(data[0]);
      csvRows.push(headers.join(","));

      // loop over the rows
      for (const row of data) {
        const values = headers.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(","));
      }
      return csvRows.join("\n");
    },

    download(data) {
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv;charset=utf-8;'});
      const url = window.URL.createObjectURL(blob);
      
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute('download', this.$t('miscpayrolllsitreport.miscpaytolllisting') + "-" + this.dataItems[0].payoutcode.toString() + ".csv"
);

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    async getCSV() {
      let item = this.dataItems;
      let data = [];

      for (var i = 0; i < item.length; i++) {
        data.push({
          [`${this.$t('columns.no')}`]: item[i].id,
          [`${this.$t('columns.name')}`]: item[i].psnname,
          [`${this.$t('columns.staffid')}`]: item[i].staffcode,
          [`${this.$t('columns.branch')}`]: item[i].brchcode,
          [`${this.$t('columns.department')}`]: item[i].deptcode,
          [`${this.$t('recfamdetails.icno')}`]: item[i].idno,         
          [`${this.$t('miscpayrolllsitreport.oldicno')}`]: item[i].oldidno,
          [`${this.$t('trainingrecord.amount')}`]: item[i].amount,
          [`${this.$t('bankpaymentlistingreport.total')}`]: "",
        });
      }

      data.push({
        [`${this.$t('columns.no')}`]: "",
        [`${this.$t('columns.name')}`]: "",
        [`${this.$t('columns.staffid')}`]: "",
        [`${this.$t('columns.branch')}`]: "",
        [`${this.$t('columns.department')}`]: "",
        [`${this.$t('recfamdetails.icno')}`]: "",        
        [`${this.$t('miscpayrolllsitreport.oldicno')}`]: "",
        [`${this.$t('trainingrecord.amount')}`]: "",
        [`${this.$t('bankpaymentlistingreport.total')}`]: this.total,
      });

      const csvData = this.objectToCSV(data);
      this.download(csvData);
    },
  },

  mounted() {},

  created() {
    const vm = this;
    vm.formData = this.$route.params.formData;
    
    if (vm.formData.poid) {
      this.showID = true;
    } else {
      this.showDate = true;
    }
    this.loadStaffMisc();
  },
};
</script>

<style>
.dateTitle {
  font-size: 12px;
  color: #ffffff;
  height: 0px;
  background-color: orange;
  align-content: center;
  justify-content: center;
}

.scroller {
  height: 100%;
}

.total {
  font-size: 15px;
}
</style>